import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useDebounce } from 'react-use'

import { DEFAULT_DEBOUNCE_TIME } from 'constants/debounce'

export const SEARCH_PARAMS_KEY = 'search'

type UseDebouncedSearchParamsValues = {
  initialSearchValue?: string
  debounceTime?: number
}

export function useDebouncedSearchParams(
  options?: UseDebouncedSearchParamsValues
): [string, (value: string) => void] {
  const { initialSearchValue = '', debounceTime = DEFAULT_DEBOUNCE_TIME } =
    options ?? {}

  const [searchValue, setSearchValue] = useState(initialSearchValue)
  const [, setSearchParams] = useSearchParams()

  // Debounce the search value to avoid too many re-renders
  useDebounce(
    () => {
      setSearchParams({ [SEARCH_PARAMS_KEY]: searchValue }, { replace: true })
    },
    debounceTime,
    [searchValue]
  )

  return [searchValue, setSearchValue]
}
